import { StateHistoryItemDTO } from "kashable-mobile-common";

import { currentServerTime } from "./DateUtil";

const stateHistory: StateHistoryItemDTO[] = [];
const MAX_HISTORY_LENGTH: number = 16;

const getStateHistory = () => stateHistory;

const addStateHistory = (state: string) => {
    if (stateHistory.length >= MAX_HISTORY_LENGTH) {
        stateHistory.shift();
    }
    stateHistory.push({
        state,
        ts: currentServerTime()
    });
}
  
export {getStateHistory, addStateHistory};
